import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios'
import { Checkbox } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from "moment";
import { AppContext } from "../../context/app/appContext";

export const PerkProgram = ({ id, name, active, startDate, endDate, frequency, onDelete, onEdit, editInProgress, resetEditInProgress, perkProgram, onAddPerks }) => {

    const [startAt, setStartAt] = useState(startDate);
    const [endAt, setEndAt] = useState(endDate);
    const [programName, setProgramName] = useState(name);
    const [endDateEnabled, setEndDateEnabled] = useState(false);
    // const [endDateCheckAltered, setEndDateCheckAltered] = useState(false);
    const [editable, setEditable] = useState(false);
    const appContext = useContext(AppContext);
    const [invalidDateRange, setInvalidDateRange] = useState(false);
    const [monthlyEndDates, setMonthlyEndDates] = useState([]);
    const [monthlyStartDates, setMonthlyStartDates] = useState([]);
    const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';

    useEffect(() => {
        const isValidEndDate = moment(endDate).isValid();
        setEndDateEnabled(isValidEndDate);
    }, [endDate]);

    useEffect(() => {
        console.info({startAt})
    }, [startAt])

    useEffect(() => {
        setMonthlyEndDates(getMonthlyEndDates(startAt));
    }, [startAt])

    useEffect(() => {
        setMonthlyStartDates(getMonthlyStartDates(currentDate));
    }, [])

    useEffect(() => {
        const invalidDateRange = endAt ? endAt <= startAt : false;
        // console.info({invalidDateRange});
        invalidDateRange ? setInvalidDateRange(true) : setInvalidDateRange(false);
    }, [startAt, endAt]);

    const makeEditable = () => {
        if (editInProgress(id)) {
            console.info(`Please finish editing existing perk program.`)
        } else {
            console.info(`PerkProgramItem: makeEditable`);
            setEditable(true);
        }
    }

    // const handleSave = async () => {
    //     console.info(`PerkProgramItem: handleSave`);
    //     const updatedProgram = {
    //         ...perkProgram,
    //         name: programName,
    //         startDate: startAt,
    //         endDate: endAt,
    //         endDateEnabled: endDateEnabled,
    //     };
    //     console.info({ updatedProgram });
    //     const programUpdateAction = await appContext.updatePerksProgram(updatedProgram);

    //     await axios.post(baseURL + '/recentActions', { task: 'Perk Program' + programName + ' Updated' }, {
    //         headers: {
    //             Authorization: "Bearer " + localStorage.getItem('accessToken')
    //         }
    //     })

    //     console.info({ programUpdateAction });
    //     setEditable(false);
    //     resetEditInProgress();
    // }

    const handleSave = async () => {
        console.info(`PerkProgramItem: handleSave`);

        var tempStartDate = startAt
        tempStartDate.setHours(startAt.getHours() - (startAt.getTimezoneOffset() / 60))
        var tempEndDate = endAt;
        tempEndDate.setHours(endAt.getHours() - (endAt.getTimezoneOffset() / 60))
        tempEndDate.setDate(endAt.getDate() + 1)

        console.table(tempStartDate, tempEndDate);
        const updatedProgram = {
            ...perkProgram,
            name: programName,
            startDate: tempStartDate,
            endDate: tempEndDate,
            endDateEnabled: endDateEnabled,
        };
        console.info({ updatedProgram });
        const programUpdateAction = await appContext.updatePerksProgram(updatedProgram);

        await axios.post(baseURL + '/recentActions', { task: 'Perk Program' + programName + ' Updated' }, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem('accessToken')
            }
        })

        console.info({ programUpdateAction });
        setEditable(false);
        resetEditInProgress();
    }

    const handleCancelEdit = () => {
        setEditable(false);
        setProgramName(name);
        setStartAt(startDate);
        setEndAt(endDate);
        setEndDateEnabled(moment(endDate).isValid());
        resetEditInProgress();
    }

    // const onAddPerks = (programId) => {
    //     history.push(`/program/${programId}/perks/add`);
    // };

    const handleToggleEndDate = (e) => {
        setEndDateEnabled(!endDateEnabled);
    }

    // const getMonthlyEndDates = (date) => {
    //     // console.info(`date: ${date}`, `new Date(): ${new Date()}`);
    //     let startDate = new Date(date);
    //     const totalMonths = 12;
    //     const validEndDates = [startDate];
    //     for (let i = 1; i <= totalMonths; i++) {
    //         let nextMonthDate = startDate.setMonth(startDate.getMonth() + 1);
    //         validEndDates.push(nextMonthDate);
    //         // console.info({nextMonthDate}, new Date(nextMonthDate));
    //     }
    //     return validEndDates;
    // }

    const getMonthlyEndDates = (date) => {
        let startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const totalMonths = 12;
        startDate.setDate(0)
        startDate.setDate(startDate.getDate() + 15)
        startDate.setMonth(startDate.getMonth() + 1)
        let tempDate = startDate.setDate(0)
        const validEndDates = [tempDate];
        for (let i = 1; i <= totalMonths; i++) {
            startDate.setDate(startDate.getDate() + 15)
            startDate.setMonth(startDate.getMonth() + 1)
            let nextMonthDate = startDate.setDate(0)
            validEndDates.push(nextMonthDate);
        }
        return validEndDates;
    }

    const getMonthlyStartDates = (date) => {
        let startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const totalMonths = 12;
        startDate.setDate(1)
        const validEndDates = [Date.parse(startDate)];
        for (let i = 1; i <= totalMonths; i++) {
            // startDate.setDate(startDate.getDate() + 15)
            startDate.setMonth(startDate.getMonth() + 1)
            let nextMonthDate = startDate.setDate(1)
            validEndDates.push(nextMonthDate);
        }
        console.log(validEndDates)
        return validEndDates;
    }

    const currentDate = new Date();
    // const startDateString = moment(startAt).format('MM/DD/YYYY');
    const startDateString = startAt.toLocaleDateString('en-US', {timeZone: 'UTC', day: '2-digit', month: '2-digit', year: 'numeric'})
    const endDateString = endDate ? moment(endDate).format('MM/DD/YYYY') : '';
    // const endDateString = endDate ? endDate.toLocaleDateString('en-US', {timezone: 'UTC', day: '2-digit', month: '2-digit', year: 'numeric'}) : '';
    const endDateField = endDateEnabled ? <DatePicker className="ui input" minDate={currentDate} selected={endAt} onChange={date => setEndAt(date)} includeDates={monthlyEndDates} /> : '-';
    const invalidEntry = ((programName === name) && (startAt === startDate) && (endAt ? endAt === endDate : true)) || invalidDateRange;

    return (
        (active ? (<tr key={id} className="center aligned" style={{ backgroundColor: 'rgba(238, 241, 243, 1)' }}>
            <td>{editable ? <input type="text" className="ui input center aligned" value={programName} onChange={e => setProgramName(e.target.value)} /> : programName}</td>
            <td width='15%'>{appContext.teams.filter(team => { return team.perksProgramId === id }).map(team => { return team.name.length > 15 ? team.name.slice(0, 13) + '...' : team.name }).join(', ')}</td>
            <td>{editable ? (<DatePicker className="ui input" minDate={monthlyStartDates[0]} selected={startAt} onChange={date => setStartAt(date)} includeDates={monthlyStartDates} />) : startDateString}</td>
            <td><Checkbox checked={endDateEnabled} disabled={!editable} onChange={handleToggleEndDate} /></td>
            <td>{editable ? endDateField : endDateString}</td>
            <td>{frequency}</td>
            <td className="right aligned row-action-buttons">
                {!editable ? (<div className={active ? 'ui button primary' : 'ui button primary disabled'} onClick={() => onAddPerks(id)}>Add/ View</div>) : ''}
                {!editable && (<button className="ui icon button" onClick={e => makeEditable(id)}><i aria-hidden="true" className="pencil alternate icon" /></button>)}
                {!editable && (<button className="ui icon button" onClick={e => onDelete(id)}><i aria-hidden="true" className="trash icon" /></button>)}

                {editable && (<button className="ui button" onClick={handleCancelEdit}>Cancel</button>)}
                {editable && (<button className="ui button primary" onClick={e => handleSave(id)}
                    disabled={invalidEntry}>Save</button>)}
            </td>
        </tr>) :
            (<tr key={id} className="center aligned disabled" style={{ backgroundColor: 'rgba(238, 241, 243, 1)' }}>
                <td>{programName}</td>
                <td width='15%'>{appContext.teams.filter(team => { return team.perksProgramId === id }).map(team => { return team.name.length > 15 ? team.name.slice(0, 13) + '...' : team.name }).join(', ')}</td>
                <td>{startDateString}</td>
                <td>{endDateString}</td>
                <td>{frequency}</td>
            </tr>)
        )
    );
};
